import {
  IReportsData,
  PharmacistLegendVariant,
  TimeFormat,
} from '@pharmaplan/common';
import {
  dateAndTime,
  DynamicTableCell,
  statusLabelMap,
} from '../../../helpers/Constants';
import strings from '../../../localization';
import { dateRecord, rateRecord } from '../../../helpers/longTermRecord';

const { text, icon, checkbox } = DynamicTableCell;

export const bookingReportHeader = () =>
  [
    { key: '0', label: strings.code, sortingKey: 'code' },
    { key: '1', label: strings.banner },
    { key: '2', label: strings.pharmacy, sortingKey: 'pharmacyName' },
    { key: '3', label: dateAndTime(), sortingKey: 'startDate' },
    { key: '4', label: strings.rate, sortingKey: 'rate' },
    { key: '6', label: 'Select Bookings', isCenterAligned: true },
  ];

export const bookingRequestRow = (
  data: Array<IReportsData>,
  timeFormat: TimeFormat,
  selectedItems: Array<string>,
  handlePress: (id: string) => () => void,
) =>
  data?.map((item) => {
    const {
      id,
      code,
      pharmacyName,
      city,
      startDate,
      endDate,
      logo,
      longTermShiftContractId,
      rate,
      weekDayPaidHourlyRate,
      weekendPaidHourlyRate,
    } = item ?? {};

    return {
      key: id,
      data: [
        {
          key: `${id}-1`,
          value: code,
          type: text,
        },
        {
          key: `${id}-2`,
          value: logo,
          type: icon,
        },
        {
          key: `${id}-3`,
          value: `${pharmacyName}\n${city}`,
          type: text,
        },
        dateRecord(
          { startDate, endDate, timeFormat },
          PharmacistLegendVariant.booked,
          longTermShiftContractId,
        ),
        rateRecord(
          { weekDayPaidHourlyRate, weekendPaidHourlyRate, rate },
          longTermShiftContractId,
        ),
        {
          key: '8',
          value: {
            checked: !!selectedItems?.includes(id),
            handlePress: handlePress(id),
          },
          isCenterAligned: true,
          type: checkbox,
        },
      ],
    };
  });
